import { useTranslation } from "react-i18next";
import { Box, HStack, Text } from "@chakra-ui/react";
import { HiX } from "react-icons/hi";
import { HiCheckCircle } from "react-icons/hi2";

const actionButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: 2,
    bg: "white",
    border: "1px solid",
    borderColor: "#D8D3E8",
    borderRadius: "9px",
    px: 4,
    py: 2,
    fontSize: "13px",
    fontWeight: 600,
    color: "#17151F",
    cursor: "pointer",
};

const BulkActionsBar = ({
    selectedCount,
    totalCount,
    isAllSelected,
    totalPages,
    onSelectAll,
    onDeselectAll,
    onChangeStatus,
    onExport,
    onSendEmail,
    isXlsxLoading,
    isSelectAllLoading,
}) => {
    const { t } = useTranslation("models");

    return (
        <Box
            position="fixed"
            bottom={4}
            left={{ base: 4, md: "96px" }}
            right={4}
            zIndex={50}
            bg="white"
            border="1px solid"
            borderColor="purple.300"
            borderRadius="14px"
            boxShadow="0 12px 32px rgba(23,21,31,0.16)"
            px={4}
            py={3}
        >
            <HStack justify="space-between" flexWrap="wrap" gap={2}>
                <HStack gap={3} flexWrap="wrap">
                    <HStack gap={2}>
                        <HiCheckCircle color="var(--chakra-colors-purple-500)" size={18} />
                        <Text color="#17151F" fontSize="sm" fontWeight={600}>
                            {t("candidatePage.bulkBar", { count: selectedCount })}
                        </Text>
                    </HStack>
                    {isAllSelected && totalPages > 1 && (
                        <Box
                            as="button" type="button" onClick={onSelectAll}
                            fontSize="xs" color="purple.600" opacity={isSelectAllLoading ? 0.6 : 1}
                            _hover={{ textDecoration: "underline" }}
                        >
                            {t("candidatePage.bulkSelectAll", { count: totalCount })}
                        </Box>
                    )}
                    <Box
                        as="button" type="button" onClick={onDeselectAll}
                        display="flex" alignItems="center" gap={1} fontSize="xs" color="#65616F"
                        _hover={{ color: "#17151F" }}
                    >
                        <HiX />
                        {t("candidatePage.bulkDeselectAll")}
                    </Box>
                </HStack>
                <HStack gap={2} flexWrap="wrap">
                    <Box as="button" type="button" onClick={onChangeStatus} {...actionButtonStyle} _hover={{ bg: "#F6F6FB" }}>
                        {t("candidatePage.bulkChangeStatus")}
                    </Box>
                    <Box as="button" type="button" onClick={onSendEmail} {...actionButtonStyle} _hover={{ bg: "#F6F6FB" }}>
                        {t("candidatePage.bulkSendMessage")}
                    </Box>
                    <Box as="button" type="button" onClick={onExport} {...actionButtonStyle} opacity={isXlsxLoading ? 0.6 : 1} _hover={{ bg: "#F6F6FB" }}>
                        {t("candidatePage.downloadXlsxSelected", { count: selectedCount })}
                    </Box>
                </HStack>
            </HStack>
        </Box>
    );
};

export default BulkActionsBar;
